import React from "react";
import { useSelector } from "react-redux";

const ODMPendingStats = ({ onNavigateToTab }) => {
  const { oneDayStats } = useSelector((state) => state.plans);
  const { gymKeywordStats } = useSelector((state) => state.prospects);
  const { recurringSubscriptionStats } = useSelector((state) => state.plans);
  const { referralStat } = useSelector((state) => state.prospects);

  const pendingLMSData = [
    {
      label: "ODM Pending LMS",
      value: oneDayStats?.data?.total_not_added_to_lead || 0,
      baseClassName: "odm-stat-pending",
      targetTab: 1,
    },
    {
      label: "Wati Pending LMS",
      value: gymKeywordStats?.data?.not_added_to_lead || 0,
      baseClassName: "odm-stat-pending",
      targetTab: 2,
    },
    {
      label: "Recurring Pending LMS",
      value: recurringSubscriptionStats?.data?.total_not_added_to_lead || 0,
      baseClassName: "odm-stat-pending",
      targetTab: 3,
    },
    {
      label: "Referral Pending LMS",
      value: referralStat?.data?.[0]?.total_not_added_to_lead || 0,
      baseClassName: "odm-stat-pending",
      targetTab: 5,
    },
  ];

  const handleCardClick = (targetTab, cardLabel) => {
    if (onNavigateToTab) {
      onNavigateToTab(targetTab);
    }
  };

  return (
    <div className="odm-stat-pending-lms-container mt30">
      <div className="odm-stat-pending-cards-grid">
        {pendingLMSData.map((item, index) => {
          const hasNoPending = item.value === 0;
          const cardClassName = hasNoPending
            ? `${item.baseClassName}-success`
            : item.baseClassName;

          return (
            <div
              key={index}
              className={`odm-stat-pending-card ${cardClassName} ${
                hasNoPending ? "odm-stat-no-pending" : "odm-stat-has-pending"
              } odm-stat-clickable`}
              onClick={() => handleCardClick(item.targetTab, item.label)}
              title={`Click to view ${item.label.replace(
                " Pending LMS",
                ""
              )} details`}
            >
              <div className="odm-stat-pending-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  {hasNoPending ? (
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  ) : (
                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                  )}
                </svg>
              </div>
              <div className="odm-stat-pending-content">
                <div className="odm-stat-pending-value">{item.value}</div>
                <div className="odm-stat-pending-label">{item.label}</div>
                {hasNoPending && (
                  <div className="odm-stat-success-text">All Clear!</div>
                )}
              </div>
              <div className="odm-stat-pending-pulse"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ODMPendingStats;
